import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Link } from "gatsby";

function Eightstepcloud() {
  return (
    <section className="eight_step_cloud cloud_infra_sol p-100">
      <Container>
        <Row>
          <Col xs={12} md={7} lg={6} xl={6} xxl={6}>
            <h2>Our Process of Cloud Infrastructure Management Solutions</h2>
          </Col>
          <Col xs={12} md={5} lg={6} xl={6} xxl={6}>
            <p>
              As a top-notch cloud infrastructure management company, we place a
              high value on teamwork to guarantee the smooth integration and
              optimization of your operations.
            </p>
            <p>
              Our strategy places a strong emphasis on working closely with your
              team to develop solutions that are specifically designed to match
              your unique business goals. Here’s how we navigate through the
              essential stages:
            </p>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Swiper
              loop={true}
              // autoplay={{
              //   delay: 3000,
              //   disableOnInteraction: false,
              // }}
              autoplay={false}
              spaceBetween={20}
              modules={[Autoplay, Pagination]}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 3,
                },
                1366: {
                  slidesPerView: 4,
                },
                1600: {
                  slidesPerView: 4,
                },
              }}
              className="eight_step_cloud_slider"
            >
              <SwiperSlide>
                <div className="cloud_step_box">
                  <div className="cloud_step_content">
                    <div className="cloud_head">
                      <h5>
                        Discovery & <br />
                        Assessment
                      </h5>
                    </div>
                    <p style={{ color: "#898989" }}>
                      We start by carefully analyzing your business goals and
                      assessing the state of your existing IT infrastructure.
                      Our team chooses the right infrastructure specifics,
                      identifying inefficiencies, and choosing appropriate tools
                      and technologies are all part of this step.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cloud_step_box">
                  <div className="cloud_step_content">
                    <div className="cloud_head">
                      <h5>Implementation & Development</h5>
                    </div>
                    <p style={{ color: "#898989" }}>
                      Our staff makes the required adjustments and optimizations
                      after learning from the evaluation process. The
                      preparation of your infrastructure for a smooth transition
                      and improved performance is the main goal of this stage.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cloud_step_box">
                  <div className="cloud_step_content">
                    <div className="cloud_head">
                      <h5>Continuous Monitoring & Maintenance</h5>
                    </div>
                    <p style={{ color: "#898989" }}>
                      After deployment, we use powerful monitoring tools to keep
                      an eye on server health, network activity, and application
                      performance in real-time. Maintaining your cloud
                      environment regularly keeps it safe, reliable, and
                      effective is our responsibility. 
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cloud_step_box">
                  <div className="cloud_step_content">
                    <div className="cloud_head">
                      <h5>
                        Optimization & <br />
                        Scaling
                      </h5>
                    </div>
                    <p style={{ color: "#898989" }}>
                      We consistently improve the scalability, speed, and
                      security of your cloud infrastructure. This entails
                      improving data management techniques, putting scalability
                      measures into place, and fine-tuning resource allocation.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cloud_step_box">
                  <div className="cloud_step_content">
                    <div className="cloud_head">
                      <h5>
                        Disaster
                        <br /> Recovery
                      </h5>
                    </div>
                    <p style={{ color: "#898989" }}>
                      To reduce downtime and guarantee company continuity in
                      times of emergency, we offer comprehensive disaster
                      recovery planning as part of our services. We implement
                      recovery protocols, failover schemes, and backup plans
                      that are customized to meet your unique requirements.
                    </p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="cloud_step_box">
                  <div className="cloud_step_content">
                    <div className="cloud_head">
                      <h5>
                        Discovery & <br />
                        Assessment
                      </h5>
                    </div>
                    <p style={{ color: "#898989" }}>
                      We start by carefully analyzing your business goals and
                      assessing the state of your existing IT infrastructure.
                      Our team chooses the right infrastructure specifics,
                      identifying inefficiencies, and choosing appropriate tools
                      and technologies are all part of this step.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cloud_step_box">
                  <div className="cloud_step_content">
                    <div className="cloud_head">
                      <h5>Implementation & Development</h5>
                    </div>
                    <p style={{ color: "#898989" }}>
                      Our staff makes the required adjustments and optimizations
                      after learning from the evaluation process. The
                      preparation of your infrastructure for a smooth transition
                      and improved performance is the main goal of this stage.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cloud_step_box">
                  <div className="cloud_step_content">
                    <div className="cloud_head">
                      <h5>Continuous Monitoring & Maintenance</h5>
                    </div>
                    <p style={{ color: "#898989" }}>
                      After deployment, we use powerful monitoring tools to keep
                      an eye on server health, network activity, and application
                      performance in real-time. Maintaining your cloud
                      environment regularly keeps it safe, reliable, and
                      effective is our responsibility.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cloud_step_box">
                  <div className="cloud_step_content">
                    <div className="cloud_head">
                      <h5>
                        Optimization & <br />
                        Scaling
                      </h5>
                    </div>
                    <p style={{ color: "#898989" }}>
                      We consistently improve the scalability, speed, and
                      security of your cloud infrastructure. This entails
                      improving data management techniques, putting scalability
                      measures into place, and fine-tuning resource allocation.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="cloud_step_box">
                  <div className="cloud_step_content">
                    <div className="cloud_head">
                      <h5>
                        Disaster
                        <br /> Recovery
                      </h5>
                    </div>
                    <p style={{ color: "#898989" }}>
                      To reduce downtime and guarantee company continuity in
                      times of emergency, we offer comprehensive disaster
                      recovery planning as part of our services. We implement
                      recovery protocols, failover schemes, and backup plans
                      that are customized to meet your unique requirements.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col
            xs={12}
            md={7}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
               Migrate to Cloud
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Eightstepcloud;
